import { Payment, Sale } from "@towersystems/roam-common/lib/generated-types";
import { useCallback } from "react";
import { FlatList } from "react-native";
import { View } from "react-native-ui-lib";
import { formatDateToCalendar } from "../../../../utilities/date/format-date";
import { moneyToFormattedString } from "../../../../utilities/money";
import { PayTypeToIcon, Text, Divider } from "@towersystems/roam-common-native";

export interface SalePaymentsSummaryProps {
  sale: Sale;
}

export const SalePaymentsSummary = ({ sale }: SalePaymentsSummaryProps) => {
  const renderItem = useCallback(({ item }: { item: Payment }) => {
    const isGiftCardPayment = item.paymentTypeId === "35";
    const isTowerPayments = item.paymentTypeId === "45";
    return (
      <View row>
        <View
          style={{
            marginRight: 20,
            width: 47,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <PayTypeToIcon payType={item.paymentTypeId} />
        </View>
        <View flex>
          <Text variant="heading1">{item.name}</Text>
          <Text variant="heading4" color="subdued">
            {formatDateToCalendar(item.paymentDate)}
          </Text>
          {isTowerPayments && (
            <View>
              {item?.metadata?.response?.deviceDescription && (
                <Text variant="heading4" color="subdued">
                  Device: {item.metadata.response.deviceDescription}
                </Text>
              )}
            </View>
          )}
          <Text variant="heading4" color="subdued">
            {item.state}
            {item.transactionId ? ` / ${item.transactionId}` : ""}
          </Text>
          {isGiftCardPayment && (
            <View>
              {item.metadata.giftCardId && (
                <Text variant="heading4" color="subdued">
                  Gift Card: {item.metadata.giftCardId} /{" "}
                  {item.metadata.transactionType}
                </Text>
              )}
            </View>
          )}
        </View>
        <View>
          <Text variant="heading1">{moneyToFormattedString(item.amount)}</Text>
        </View>
      </View>
    );
  }, []);

  return (
    <FlatList
      scrollEnabled={false}
      ItemSeparatorComponent={Divider}
      data={sale.payments}
      renderItem={renderItem}
    ></FlatList>
  );
};
